import { CurrentUser } from "../../common/providers/current-user";
import { Voter } from '../../common/security/voter';
import { CurrentUserRolesProvider } from '../../organizations/providers/current-user-roles-provider';
import { Injectable } from '@angular/core';
import { OrganizationRole } from "../../common/models/organization-role";
import { EvaluationAthlete } from "../../common/models/evaluation-athlete";

@Injectable({providedIn: 'root'})
export class EvaluationAthleteVoter extends Voter {
    public static readonly EDIT: string = 'edit';

    constructor(
        private currentUserRolesProvider: CurrentUserRolesProvider,
    ) {
        super();
    }

    protected supports(attribute:any, subject:any): boolean {
        return ([
            EvaluationAthleteVoter.EDIT
        ].indexOf(attribute) !== -1) && subject instanceof EvaluationAthlete;
    }

    protected voteOnAttribute(attribute: string, subject: any, currentUser: CurrentUser): boolean {
        if (!currentUser.hasOwnProperty('organization')) {
            return false;
        }

        /**
         * Admin can do everything
         */
        if (currentUser.user!.isAdmin) {
            // return true; // TODO : VH - uncomment if admin can do everything
        }

        /**
         * Stability evaluations can be edited by COACH only
         */
        if (EvaluationAthleteVoter.EDIT === attribute) {
            const roles = this.currentUserRolesProvider.getRolesIds(currentUser.organization?.id!);

            if (subject.evaluation.type === 'stability') {
                return (roles.indexOf(OrganizationRole.ID_COACH) !== -1);
            }

            return true;
        }

        return false;
    }
}
